import TeamsAPI from '../../api/teams';

export const SET_TEAM_MEMBERS_UI_FLAG = 'SET_TEAM_MEMBERS_UI_FLAG';
export const ADD_AGENTS_TO_TEAM = 'ADD_AGENTS_TO_TEAM';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getTeamMembers: $state => id => {
    return $state.records[id] || [];
  },
};

// Convierte agentsWithRoles [{ id, role }] al formato del backend: [{ user_id, role }].
const toMembersPayload = agentsWithRoles =>
  agentsWithRoles.map(({ id, role }) => ({
    user_id: id,
    role: role || 'member',
  }));

export const actions = {
  get: async ({ commit }, { teamId }) => {
    commit(SET_TEAM_MEMBERS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await TeamsAPI.getAgents({ teamId });
      commit(ADD_AGENTS_TO_TEAM, { data, teamId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TEAM_MEMBERS_UI_FLAG, { isFetching: false });
    }
  },
  // Acepta:
  //   - agentsList: legacy (array de IDs, todos como 'member')
  //   - agentsWithRoles: nuevo formato [{ id, role }] que permite roles distintos por agente
  create: async ({ commit }, { agentsList, agentsWithRoles, teamId }) => {
    commit(SET_TEAM_MEMBERS_UI_FLAG, { isCreating: true });
    try {
      const opts = { teamId };
      if (agentsWithRoles) {
        opts.members = toMembersPayload(agentsWithRoles);
      } else {
        opts.agentsList = agentsList;
      }
      // eslint-disable-next-line no-console
      console.log('[teamMembers.create] payload:', opts);
      const { data } = await TeamsAPI.addAgents(opts);
      commit(ADD_AGENTS_TO_TEAM, { teamId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TEAM_MEMBERS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { agentsList, agentsWithRoles, teamId }) => {
    commit(SET_TEAM_MEMBERS_UI_FLAG, { isUpdating: true });
    try {
      const opts = { teamId };
      if (agentsWithRoles) {
        opts.members = toMembersPayload(agentsWithRoles);
      } else {
        opts.agentsList = agentsList;
      }
      // eslint-disable-next-line no-console
      console.log('[teamMembers.update] payload:', opts);
      const { data } = await TeamsAPI.updateAgents(opts);
      commit(ADD_AGENTS_TO_TEAM, { teamId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TEAM_MEMBERS_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [SET_TEAM_MEMBERS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [ADD_AGENTS_TO_TEAM]($state, { data, teamId }) {
    $state.records = {
      ...$state.records,
      [teamId]: data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
